
export const TOGGLE_LEFT = 'TOGGLE_LEFT';
export const TOGGLE_RIGHT = 'TOGGLE_RIGHT';


// WEBPACK FOOTER //
// ./src/data/menus/types.js